import { useEffect } from "react";
import { LoadCanvasTemplateNoReload } from "react-simple-captcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import useCaptchaStore from "./useCaptchaStore";
import "./captcha.css";

const Captcha = () => {
  const {
    captchaInput,
    captchaError,
    loadCaptcha,
    updateCaptchaInput,
    resetCaptcha,
  } = useCaptchaStore();

  useEffect(() => {
    loadCaptcha();
  }, [loadCaptcha]);

  return (
    <div className="captcha-field">
      <div className="captcha-bar">
        <div className="captcha-display">
          <LoadCanvasTemplateNoReload />
        </div>
        <button
          type="button"
          className="captcha-refresh-btn"
          onClick={resetCaptcha}
          aria-label="Refresh captcha"
        >
          <FontAwesomeIcon icon={faArrowsRotate} />
        </button>
        <input
          type="text"
          className="captcha-input"
          placeholder="Enter Captcha"
          value={captchaInput}
          onChange={(e) => updateCaptchaInput(e.target.value)}
        />
      </div>
      {captchaError && <p className="captcha-error">{captchaError}</p>}
    </div>
  );
};

export default Captcha;
